const Divider = () => {
  return {
    MuiDivider: {
      styleOverrides: {
        fullWidth: {
          width: '100%',
        },
      },
    },
  };
};

export default Divider;
